import React from "react";

/**
 * The Newfangle Media rate card — ported verbatim from the original static
 * public_html/index.html. Copy and prices are load-bearing (see CLAUDE.md): the plain-dealing,
 * no-surprises voice is deliberate. Styling lives in index.css; keep prices in sync with the
 * ../shane pricing poster.
 */
export default function RateCard({ onTalk }) {
  return (
    <>
      <header className="masthead">
        <div className="wrap">
          <div className="brandline">
            <span className="wordmark">Newfangle Media<span className="llc"> LLC</span></span>
            <span className="type-label">Web &amp; Software — Rate Card</span>
          </div>
          <h1>Four ways to put your business <em>online.</em></h1>
          <p className="lede">From a site that texts you every lead to a system that routes work to your whole crew. Start where you are, step up when the work justifies it — the terms are the same at every level, and they're all right here.</p>
        </div>
      </header>

      <main className="wrap">
        <section className="grid">

          {/* BRONZE */}
          <article className="tier">
            <div className="tier-meta">01 · Bronze</div>
            <div className="tier-name">Live</div>
            <div className="tier-tag">on the map, answering</div>
            <div className="price"><span className="cur">$</span><span className="num">1,800</span><span className="per">once</span></div>
            <div className="monthly">then <b>$25</b> / month</div>
            <div className="incl">Included</div>
            <ul className="feats">
              <li>A custom site, live on your own domain</li>
              <li>Your real content — words, services, a starter set of photos</li>
              <li>Mobile-first: fast on any phone, any connection</li>
              <li>Contact button sends every lead straight to your phone by text &amp; email</li>
              <li>30 days of post-launch fixes</li>
            </ul>
          </article>

          {/* SILVER */}
          <article className="tier featured">
            <span className="flag">The sweet spot</span>
            <div className="tier-meta">02 · Silver</div>
            <div className="tier-name">Live &amp; Legit</div>
            <div className="tier-tag">looks like an established business</div>
            <div className="price"><span className="cur">$</span><span className="num">3,600</span><span className="per">once</span></div>
            <div className="monthly">then <b>$75</b> / month</div>
            <div className="incl">Included</div>
            <ul className="feats">
              <li className="carry">Everything in Bronze, plus</li>
              <li>A full portfolio gallery of your finished work</li>
              <li>A testimonials showcase from real customers</li>
              <li>Your business social page, set up and branded</li>
              <li>An ongoing support plan — not a one-and-done</li>
            </ul>
          </article>

          {/* GOLD */}
          <article className="tier">
            <div className="tier-meta">03 · Gold</div>
            <div className="tier-name">Organized</div>
            <div className="tier-tag">every lead tracked, nothing dropped</div>
            <div className="price"><span className="cur">$</span><span className="num">6,500</span><span className="per">once</span></div>
            <div className="monthly">then <b>$120</b> / month</div>
            <div className="incl">Included</div>
            <ul className="feats">
              <li className="carry">Everything in Silver, plus</li>
              <li>Your intake form feeds a private job board</li>
              <li>Every lead becomes a tracked card: new → contacted → quoted → won</li>
              <li>Text &amp; email still fire as a backup, always</li>
              <li>Priority support</li>
            </ul>
          </article>

          {/* PLATINUM */}
          <article className="tier">
            <div className="tier-meta">04 · Platinum</div>
            <div className="tier-name">Automated</div>
            <div className="tier-tag">the operation runs itself</div>
            <div className="price"><span className="cur">$</span><span className="num">11,000</span><span className="per">once</span></div>
            <div className="monthly">then <b>$200</b> / month</div>
            <div className="incl">Included</div>
            <ul className="feats">
              <li className="carry">Everything in Gold, plus</li>
              <li>Route overflow work to a roster of trusted partners</li>
              <li>Offer / accept / decline, handled automatically</li>
              <li>Custom automation built around how you actually work</li>
            </ul>
          </article>

        </section>
      </main>

      <section className="terms">
        <div className="wrap">
          <h2>The same deal, every time.</h2>
          <p className="terms-lede">No moving targets, no "we'll settle up later." The number on the card is the number.</p>
          <div className="terms-grid">
            <div className="term">
              <div className="term-n">i.</div>
              <h3>Half now, half at launch</h3>
              <p>50% to start, 50% when it goes live — in writing, every project. You always know the total before we begin.</p>
            </div>
            <div className="term">
              <div className="term-n">ii.</div>
              <h3>The monthly earns its keep</h3>
              <p>Hosting, updates, fixes, and support live in the plan. It's a service, not a favor — and never an invoice you didn't see coming.</p>
            </div>
            <div className="term">
              <div className="term-n">iii.</div>
              <h3>Start anywhere, move up</h3>
              <p>Pick a tier today and step up when the work justifies it. What you spent on the last tier carries forward into the next.</p>
            </div>
          </div>
        </div>
      </section>

      <footer className="foot">
        <div className="wrap">
          <div className="foot-cta">Got a project in mind? <button type="button" className="talk-link" onClick={onTalk}>Let's talk.</button></div>
          <div className="foot-meta">
            Newfangle Media LLC
          </div>
        </div>
      </footer>
    </>
  );
}
